import { GallonsPerMinute } from "@/libs/units/flowRate";

export function getHazenWilliamsFrictionLossPSIA(
  pipeDiameterIn: number,
  liquidFlowRateBbld: number,
  hazenWilliamsCoefficient: number,
  tubingLengthFt: number,
  fluidSpecificGravity: number
): number {
  if (hazenWilliamsCoefficient !== 0) {
    const hydraulicDiameterIn =
      (4 * (Math.PI * (pipeDiameterIn / 2) ** 2)) /
      (2 * Math.PI * (pipeDiameterIn / 2));

    const liquidFlowRateGPM = GallonsPerMinute.toThisUnit(liquidFlowRateBbld);
    const h100 =
      (0.2083 *
        (100 / hazenWilliamsCoefficient) ** 1.852 *
        liquidFlowRateGPM ** 1.852) /
      hydraulicDiameterIn ** 4.8655;
    const frictionLossFt = h100 * (tubingLengthFt / 100);
    return (frictionLossFt * 0.4335) / fluidSpecificGravity;
  } else {
    return 0;
  }
}
